import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GalleryComponent } from 'src/app/view/gallery/gallery.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';



@NgModule({
  declarations: [
    GalleryComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild([
      {path:'',component:GalleryComponent}
    ]),
    SharedModule
  ]
})
export class GalleryModule { }
